import React from 'react'
import {has, last, intersection, keys, isNil, isEmpty} from 'lodash'
import {defaultSizes} from 'theme/sizes'
import Icon from '../components/icon'

export const getSizeProp = (props) => {
  if (has(props, 'size')) {
    return props.size
  }
  return last(intersection(keys(defaultSizes), keys(props)))
}

export const normaliseToArray = (i) => (i instanceof Array) ? i : [i]

// Converts a string to a 1 index array
export const normaliseStrArray = (i) => {
  if (i instanceof Array) {
    return i
  } else if (typeof i === 'string') {
    return [i]
  } else {
    throw `${i}. This is not a string or an array, cannot normalise`
  }
}

export const prefixString = (prefix, str, ...additional) => {
  const prefixArr = [...normaliseStrArray(prefix), ...additional]
  return prefixArr.map(pre => pre + str).join(' ')
}

export const prefix = (prefix, ...additional) => {
  return (className) => {
    if (className instanceof Array) {
      return className.filter(name => name != null).map(name => prefixString(prefix, name, ...additional)).join(' ')
    }
    return prefixString(prefix, className, ...additional)
  }
}
export const iconProp = prop => {
  if (React.isValidElement(prop)) {
    return prop
  } else if (typeof prop === 'string') {
    return props => <Icon name={prop} {...props} />
  } else {
    return null
  }
}

const newlineRegex = /(\r\n|\r|\n)/g

export const nl2br = (str) => {
  if (typeof str === 'number') {
    return str
  } else if (typeof str !== 'string') {
    return ''
  }

  return str.split(newlineRegex).map(function (line, index) {
    if (line.match(newlineRegex)) {
      return React.createElement('br', {key: index})
    }
    return line
  })
}

// Capitalises a string
export const capitalize = string => string.replace(/\b\w/g, l => l.toUpperCase())

export const isTouch = () => window.isTouch

export const getWindowScrollPosition = () => {
  const body = document.body
  const docEl = document.documentElement

  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft

  return {
    scrollTop,
    scrollLeft,
  }
}

// gets the offset for an element (like jquery offset)
export const offset = (elem) => {
  if (elem) {
    const box = elem.getBoundingClientRect()

    const body = document.body
    const docEl = document.documentElement

    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop
    const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft

    const clientTop = docEl.clientTop || body.clientTop || 0
    const clientLeft = docEl.clientLeft || body.clientLeft || 0

    const top = box.top + scrollTop - clientTop
    const left = box.left + scrollLeft - clientLeft
    return {top: Math.round(top), left: Math.round(left)}
  }
  return null
}

export const redirectPost = (url, data) => {
  const form = document.createElement('form')
  document.body.appendChild(form)
  form.method = 'post'
  form.action = url
  for (const name in data) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = data[name]
    form.appendChild(input)
  }
  form.submit()
}

export const debounce = (fn, delay) => {
  let timer = null
  return function () {
    const context = this, args = arguments
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, delay)
  }
}

export const isKeyExpanded = (expanded, key) => {
  return Array.isArray(expanded)
    ? expanded.includes(key)
    : expanded.has(key)
}

export const isShouldAutoSubmit = (isLastInput, showTrustDevice, value, index, code) => {
  const finalCode = [...code]
  finalCode[index] = value
  const isComplete = finalCode.every(digit => !isEmpty(digit))
  return !isNil(value) && isLastInput && !showTrustDevice && isComplete
}
